import { Heading, VStack } from '@chakra-ui/react'
import React from 'react'

const UnauthorizedPage = () => {
  return (
    <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
      <Heading size="lg">Unauthorized Access</Heading>
    </VStack>
  )
}

export default UnauthorizedPage
